import type { PptxChart } from '@auw/workspace-utils';

/** Stacks accumulate independently above/below zero; overlap is not stacking. */
export function chartBarGeometry(chart: PptxChart) {
  const stacked = chart.type === 'bar' && ['stacked', 'percentStacked'].includes(chart.grouping ?? '');
  const percent = stacked && chart.grouping === 'percentStacked';
  const count = Math.max(...chart.series.map(s => s.values.length), 1);
  const positive = Array<number>(count).fill(0);
  const negative = Array<number>(count).fill(0);
  const totals = Array.from({ length: count }, (_, i) => chart.series.reduce((sum, s) => sum + Math.abs(s.values[i] ?? 0), 0));
  const segments = chart.series.map(series => series.values.map((raw, i) => {
    if (raw === null) return null;
    const value = percent ? raw / (totals[i] || 1) : raw;
    const bucket = value >= 0 ? positive : negative;
    const start = stacked ? bucket[i] : 0;
    const end = start + value;
    if (stacked) bucket[i] = end;
    return { start, end, value };
  }));
  const ends = segments.flatMap(row => row.flatMap(segment => segment ? [segment.start, segment.end] : []));
  return { stacked, segments, dataMin: Math.min(0, ...ends), dataMax: Math.max(0, ...ends) };
}
